import * as React from 'react';
import { Hand } from '../../mahjong/components/Hand';
import { YAKU_DATA } from '../../../models/Mahjong';

export function YakuList(): JSX.Element {
    return (
        <div className="flex-vertical gap-2 ma-2 flex-fill">
            <h2 className="white-text">Yaku List</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 450px), 1fr))', gap: '16px' }}>
                {YAKU_DATA.map((yaku, index) => (
                    <div key={index} className="basic-box flex-vertical gap-1">
                        <div className="flex justify-between align-center">
                            <h3 className="ma-0">{yaku.name}</h3>
                            <div className="flex gap-2">
                                <span>Closed: {yaku.han_closed === 13 ? "Yakuman" : yaku.han_closed + " Han"}</span>
                                {yaku.han_open !== null && (
                                    <span>Open: {yaku.han_open === 13 ? "Yakuman" : yaku.han_open + " Han"}</span>
                                )}
                                {yaku.han_open === null && (
                                    <span className="grey-text">Closed Only</span>
                                )}
                            </div>
                        </div>
                        <p className="ma-0">{yaku.description}</p>
                        <div className="mt-2">
                            <Hand tiles={yaku.example} tileHeight={40} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
